import request from 'axios';
/**
 *
 * @param {*} current
 * @param {*} size
 * @param {*} params
 * @returns
 */
export const getList = (params) => {
  return request({
    url: '/lebo-resource/rabbitsupplier/page',
    method: 'get',
    params
  })
}
export const remove = (ids) => {
  return request({
    url: '/lebo-resource/rabbitsupplier/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}
//新增或修改供应商
export const submit = (row) => {
  return request({
    url: '/lebo-resource/rabbitsupplier/submit',
    method: 'post',
    data: row
  })
}
//能力配置-详情
export const detail = (id) => {
  return request({
    url: '/lebo-resource/rabbitdeviceinfo/detail',
    method: 'get',
    params: {
      id,
    }
  })
}
//新增或修改能力
export const submitDevice = (row) => {
  return request({
    url: '/lebo-resource/rabbitdeviceinfo/submit',
    method: 'post',
    data: row
  })
}
